define('view/form/rich.text.content.view',['require','exports','module','formkit/formkit','redactor/redactor'],function(require, exports, module) {
  //prettier-ignore
  var FormKit  = require('formkit/formkit'),
      Redactor = require('redactor/redactor');

  var PreviewAnswerView = FormKit.BaseInputContentView.PreviewAnswerView.extend({
    options: {
      readonly: false,
    },

    internalViewBindings: {
      inputView: {
        readonly: 'readonly',
      },
    },

    internalViewOptions: FormKit.BaseInputContentView.PreviewAnswerView.extendInternalViewOptions({
      inputView: function() {
        return {
          type: Redactor.RedactorView,
        };
      },
    }),

    onInputViewFocus: function() {
      this.form.triggerBeginEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form),
      });
    },

    onInputViewBlur: function() {
      this.form.triggerEndEditAnswerEvent(this, this.model, {
        answerValueModel: this.getAndLinkAnswerValueModel(this.model, this.form),
      });
    },
  });

  var RichTextContentView = FormKit.BaseInputContentView.extend({
    internalViewOptions: FormKit.BaseInputContentView.extendInternalViewOptions({
      previewAnswerView: function() {
        return {
          type: PreviewAnswerView,
        };
      },
    }),
  });

  RichTextContentView.RichTextInput = Redactor.RedactorView;

  module.exports = RichTextContentView;
});

